import { formatMoney } from '../../utils/formatOpportunityValues';
export const recurringAdhocEvidenceLines = (evidence, texts, locale)=>[
        texts.occurrenceCount({
            count: evidence.occurrenceCount
        }),
        texts.avgAmount({
            amount: formatMoney(evidence.avgAmount, locale)
        }),
        evidence.cadenceEstimateDays == null ? texts.cadenceUnknown() : texts.cadence({
            count: evidence.cadenceEstimateDays
        })
    ];
